import { AlertTriangle } from "lucide-react";

export default function ImportantNotice({ t }) {
  const n = t.notice;
  return (
    <section className="py-12 sm:py-16" data-testid="important-notice-section">
      <div className="max-w-5xl mx-auto px-6 sm:px-10">
        <div className="reveal relative overflow-hidden rounded-3xl border-2 border-amber-400 bg-amber-50 p-8 sm:p-10 shadow-[0_10px_30px_rgba(217,119,6,0.12)]">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-amber-400" />
          <div className="flex flex-col sm:flex-row gap-5 sm:gap-7">
            <div className="w-12 h-12 shrink-0 rounded-2xl bg-amber-400 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-white" />
            </div>
            <div>
              <span className="label-eyebrow !text-amber-700">{n.label}</span>
              <h2 className="font-heading text-2xl sm:text-3xl text-[var(--heading)] mt-1 mb-4">
                {n.title}
              </h2>
              <p className="font-bold text-slate-800 mb-3">{n.greeting}</p>
              <p className="text-slate-700 leading-relaxed mb-3">{n.p1}</p>
              <p className="text-slate-800 font-semibold leading-relaxed mb-3">{n.p2}</p>
              <p className="text-slate-700 leading-relaxed">{n.p3}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
